import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getText } from 'helpers/i18n';

import './text.styles.scss';

export default class Text extends Component {
    render() {
        const { textKey, options } = this.props;
        const text = getText(textKey, options);

        if (this.extensionEnabled()) {
            // Use <mark> tag to mark text. Use .mark-disabled class to add/remove the yellow background
            return <mark className="mark-disabled" data-translate={this.props.textKey}>{text}</mark>;
        }

        // When extension is not enabled, return the plain text
        return text;
    }

    extensionEnabled() {
        // div#extension-container is injected by the extension when enabled
        // bug: not reliable. it doesn't always work. todo: find a fix
        return !!document.getElementById('extension-container');
    }
}

Text.propTypes = {
    textKey: PropTypes.string,
    options: PropTypes.object,
};
